import React, { ReactNode, useMemo } from 'react';
import { mui } from '~/tools/mui';
import { ListSkeleton, SortableTableHead } from '~/views/UI.shared';
import { SurveyColumn } from '~/interfaces/survey.interface';

type BasicTableProps = {
  columns: SurveyColumn[];
  orderBy: string | null;
  order?: 'asc' | 'desc';
  isLoading: boolean;
  loadingRowsCount?: number;
  loadingRowHeight?: number;
  onChangeSorting: Function;
  children: ReactNode;
};

export const BasicTable = ({
  columns,
  orderBy,
  order,
  isLoading,
  loadingRowsCount = 10,
  loadingRowHeight,
  onChangeSorting,
  children,
}: BasicTableProps) => {
  const columnsCount = useMemo(() => columns?.length ?? 0, [columns]);

  return (
    <>
      <mui.Table>
        <SortableTableHead columns={columns} orderBy={orderBy} order={order} onChangeSorting={onChangeSorting} />
        <mui.TableBody>
          {isLoading && (
            <mui.TableRow>
              <mui.TableCell colSpan={columnsCount}>
                {isLoading && <ListSkeleton rowsCount={loadingRowsCount} rowHeight={loadingRowHeight} />}
              </mui.TableCell>
            </mui.TableRow>
          )}
          {!isLoading && children}
        </mui.TableBody>
      </mui.Table>
    </>
  );
};
